import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from '../config/api';

import './ChatCompletedPage.css'; // Include your CSS styles

function ChatCompletedPage() {
  const { chatId } = useParams();
  const [agentDetails, setAgentDetails] = useState(null);

  useEffect(() => {
    const fetchAgentDetails = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/chat/${chatId}/agent`);
        const data = await response.json();
        setAgentDetails(data);
      } catch (error) {
        console.error('Error fetching agent details:', error);
      }
    };

    fetchAgentDetails();
  }, [chatId]);

  if (!agentDetails) {
    return <div>Loading...</div>;
  }

  return (
    <div className="chat-completed-page">
      <h1>This chat session is completed.</h1>
      <p>If you have further questions, please feel free to contact </p>
        <img 
          src={agentDetails.profileImage} 
          alt={`${agentDetails.firstName} ${agentDetails.lastName}`} 
          className="agent-profile-image" 
        />
        <div className='agent-name'> {agentDetails.firstName} {agentDetails.lastName} </div>
        <div className='contact'>phone: <a href={`tel:${agentDetails.phone}`}>{agentDetails.phone}</a></div>
        <div className='contact'>email: <a href={`mailto:${agentDetails.email}`}>{agentDetails.email}</a></div>
        <div className='contact'><a href={agentDetails.profile} target="_blank" rel="noopener noreferrer">View full profile</a></div>
    </div>
  );
}

export default ChatCompletedPage;